/* unplugin-vue-components disabled */import script from "./purchaseDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaseDailog.vue?vue&type=script&setup=true&lang=js"

import "./purchaseDailog.vue?vue&type=style&index=0&id=31020bb6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31020bb6"]])

export default __exports__